import { ApiProperty } from '@nestjs/swagger';

export class UploadLogoDto {
  @ApiProperty({ type: 'string', format: 'binary', description: 'Archivo de imagen (PNG, JPG, JPEG)' })
  file: Express.Multer.File;
}

export const body_empresa_logo = {
  schema: {
    type: 'object',
    properties: {
      file: { type: 'string', format: 'binary', description: 'Archivo de imagen (PNG, JPG, JPEG)' },
    },
    required: ['file'],
  },
};

export const response_empresa_logo = {
  description: 'Logo subido exitosamente',
  schema: {
    type: 'object',
    properties: {
      success: { type: 'boolean', example: true },
      message: { type: 'string', example: 'Logo actualizado exitosamente' },
      data: {
        type: 'object',
        properties: {
          logo: { type: 'string', example: 'https://bucket.example.com/logos/empresa-123.png' },
        },
      },
    },
  },
};
